import { IArticle, IIntegratedCare, IPlannedOrderedArticleLine } from '@alberta/konexi-shared';
import { Injectable } from '@angular/core';
import { ArticleDB } from 'src/app/common/repository/databases';

import { CrossTherapyArticleLineViewModel } from '../../business/cross-therapy/cross-therapy-article-line-view-model';
import { QueryService } from './query/query.service';

@Injectable({ providedIn: 'root' })
export class CrossTherapyDocumentService {
  public async enhanceArticles(
    integratedCares: IIntegratedCare[],
    queryService: QueryService
  ): Promise<CrossTherapyArticleLineViewModel[]> {
    const directOrderArticleLines = [];
    await Promise.all(
      integratedCares.map(async integratedCare => {
        const articleIds = integratedCare.proposedArticleLines.reduce((ids, articleLine) => {
          if (articleLine.articleId) {
            ids.push(articleLine.articleId);
          }
          return ids;
        }, new Array<string>());

        const articles = await queryService.search<IArticle>(
          { query: articleIds.map(articleId => `_id:${articleId}`).join(' ') },
          ArticleDB,
          { isIn: true }
        );
        for (const article of articles) {
          const newArticleLine = new CrossTherapyArticleLineViewModel();
          newArticleLine.initialize(article);
          newArticleLine.quantity = 0;
          newArticleLine.therapyId = integratedCare.therapyId;
          newArticleLine.therapyTypeId = integratedCare.therapyTypeId;
          newArticleLine.doctorId = integratedCare.doctorId;

          directOrderArticleLines.push(newArticleLine);
        }
      })
    );
    return directOrderArticleLines;
  }

  public async plannedOrderArticleLinesToCrossTherapy(
    articleLines: IPlannedOrderedArticleLine[],
    queryService: QueryService
  ): Promise<CrossTherapyArticleLineViewModel[]> {
    const crossTherapyArticleLines = [];
    await Promise.all(
      articleLines.map(async articleLine => {
        const article = await queryService.get<IArticle>(articleLine.articleId, ArticleDB);
        if (article) {
          const crossTherapyArticleLine = new CrossTherapyArticleLineViewModel();
          crossTherapyArticleLine.initialize(article);
          crossTherapyArticleLine.quantity = articleLine.quantity;
          crossTherapyArticleLine.therapyId = articleLine.therapyId;
          crossTherapyArticleLine.therapyTypeId = articleLine.therapyTypeId;
          crossTherapyArticleLine.serialNumber = articleLine.serialNumber;
          crossTherapyArticleLine.batchNumber = articleLine.batchNumber;
          crossTherapyArticleLine.salesLineId = articleLine.salesLineId;
          crossTherapyArticleLine.validTo = articleLine.validTo;
          if (articleLine.deliveredQuantity > 0) {
            crossTherapyArticleLine.storageLocation = articleLine.storageLocation;
          }
          const articleLinePackagingUnit = article.packagingUnits.find(
            packagingUnit => packagingUnit.unit === articleLine.unit
          );
          crossTherapyArticleLine.packagingUnit = articleLinePackagingUnit;
          crossTherapyArticleLine.packagingUnitQuantity = articleLinePackagingUnit.quantity;
          crossTherapyArticleLines.push(crossTherapyArticleLine);
        }
      })
    );
    return crossTherapyArticleLines;
  }
}
